var l = function l(_ref) {
  var t = _ref.baseOrigin,
    e = _ref.version;
  return {
    homePage: [{
      columnName: "Company",
      links: [{
        title: "Home",
        href: "".concat(t, "/")
      }, {
        title: "About Us",
        href: "".concat(t, "/about-us"),
        areaLabel: "check who we are"
      }, {
        title: "Affiliate Program",
        href: "".concat(t, "/affiliate-program")
      }, {
        title: "Data Methodology",
        href: "".concat(t, "/data-methodology")
      }, {
        title: "Pricing",
        href: "".concat(t, "/pricing")
      }]
    }, {
      columnName: "Product",
      links: [{
        title: "Property Management",
        href: "".concat(t, "/product/dynamic-pricing")
      }, {
        title: "Mashboard",
        href: "".concat(t, "/product/mashboard")
      }, {
        title: "API",
        href: "".concat(t, "/data-api")
      }, {
        title: "Landlord Insurance",
        href: "".concat(t, "/insurance")
      }, {
        title: "Mortgage",
        href: "".concat(t, "/mortgage")
      }, {
        title: "Invest",
        href: "".concat(t, "/invest/")
      }, {
        title: "Vacation Rental Software",
        href: "".concat(t, "/vacation-rental-software")
      }],
      extendedColumn: {
        columnName: "Solutions",
        links: [{
          title: "Property Managers",
          href: "".concat(t, "/product/mashboard-property-manager")
        },, {
          title: "First Time Investors",
          href: "".concat(t, "/product/mashboard-first-time-investor")
        }]
      }
    }, {
      columnName: "Features",
      links: [{
        title: "Airbnb Dynamic Pricing",
        href: "".concat(t, "/features/dynamic-pricing")
      }, {
        title: "Airbnb Calculator",
        href: "".concat(t, "/airbnb-calculator")
      }, {
        title: "Mortgage Calculator",
        href: "".concat(t, "/mortgage-calculator")
      }, {
        title: "Market Finder",
        href: "".concat(t, "/product/market-finder")
      }, {
        title: "Property Finder",
        href: "".concat(t, "/explore/property-finder")
      }, {
        title: "Property Marketplace",
        href: "".concat(t, "/product/marketplace")
      }, {
        title: "Airbnb API",
        href: "".concat(t, "/features/airbnb-api")
      }, {
        title: "Airbnb Data",
        href: "".concat(t, "/airbnb-data")
      }, {
        title: "IDX Website Builder",
        href: "".concat(t, "/idx-website-builder")
      }, {
        title: "Unified Inbox",
        href: "".concat(t, "/inbox")
      }, {
        title: "Channel Manager",
        href: "".concat(t, "/vacation-rental-channel-manager")
      }, {
        title: "Multi-Calendar",
        href: "".concat(t, "/multi-calendar")
      }]
    }, {
      columnName: "Resources",
      links: [{
        title: "Blog",
        href: "".concat(t, "/blog/")
      }, {
        title: "Help Center",
        href: "https://help.mashvisor.com/en"
      }, {
        title: "Training Videos",
        href: "".concat(t, "/support-videos")
      }, {
        title: "Partners",
        href: "".concat(t, "/partners")
      }, {
        title: "Real Estate Investing Guide",
        href: "".concat(t, "/blog/real-estate-investing-guide/")
      }, {
        title: "Vacation Rental Guide",
        href: "".concat(t, "/blog/vacation-rental-guide/")
      }, {
        title: "Best Airbnb Markets",
        href: "".concat(t, "/blog/best-cities-for-airbnb/")
      }, {
        title: "Investor Resource Center",
        href: "".concat(t, "/blog/investor-tools/")
      }, {
        title: "FAQ",
        href: "".concat(t, "/faq")
      }, {
        title: "Glossary",
        href: "".concat(t, "/blog/real-estate-investing-terms/")
      }, {
        title: "Compare",
        href: "".concat(t, "/blog/airdna-alternatives/")
      }]
    }, {
      columnName: "Explore",
      links: [{
        title: "Airbnb for Sale",
        href: "".concat(t, "/airbnb-for-sale")
      }, {
        title: "Sitemap",
        href: "".concat(t, "/sitemap")
      }]
    }],
    landingPages: [{
      columnName: "Company",
      links: [{
        title: "Home",
        href: "".concat(t, "/")
      }, {
        title: "About Us",
        href: "".concat(t, "/about-us"),
        areaLabel: "check who we are"
      }, {
        title: "Pricing",
        href: "".concat(t, "/pricing")
      }]
    }, {
      columnName: "Product",
      links: [{
        title: "API",
        href: "".concat(t, "/data-api")
      }, {
        title: "Invest",
        href: "".concat(t, "/invest/")
      }, {
        title: "Landlord Insurance",
        href: "".concat(t, "/insurance")
      }, {
        title: "Vacation Rental Software",
        href: "".concat(t, "/vacation-rental-software")
      }]
    }, {
      columnName: "Features",
      links: [{
        title: "Airbnb API",
        href: "".concat(t, "/features/airbnb-api")
      }, {
        title: "Airbnb Data",
        href: "".concat(t, "/airbnb-data")
      }, {
        title: "Market Finder",
        href: "".concat(t, "/product/market-finder")
      }, {
        title: "Property Finder",
        href: "".concat(t, "/explore/property-finder")
      }, {
        title: "Airbnb Calculator",
        href: "".concat(t, "/airbnb-calculator")
      }, {
        title: "Mortgage Calculator",
        href: "".concat(t, "/mortgage-calculator")
      }, {
        title: "Property Marketplace",
        href: "".concat(t, "/product/marketplace")
      }, {
        title: "Airbnb Dynamic Pricing",
        href: "".concat(t, "/features/dynamic-pricing")
      }]
    }, {
      columnName: "Resources",
      links: [{
        title: "Blog",
        href: "".concat(t, "/blog/")
      }, {
        title: "Help Center",
        href: "https://help.mashvisor.com/en"
      }, {
        title: "Vacation Rental Guide",
        href: "".concat(t, "/blog/vacation-rental-guide/")
      }, {
        title: "Investor Resource Center",
        href: "".concat(t, "/blog/investor-tools/")
      }, {
        title: "Real Estate Investing Guide",
        href: "".concat(t, "/blog/real-estate-investing-guide/")
      }]
    }],
    others: [{
      columnName: "Company",
      links: [{
        title: "Home",
        href: "".concat(t, "/")
      }, {
        title: "About Us",
        href: "".concat(t, "/about-us"),
        areaLabel: "check who we are"
      }, {
        title: "Pricing",
        href: "".concat(t, "/pricing")
      }]
    }, {
      columnName: "Product",
      links: [{
        title: "API",
        href: "".concat(t, "/data-api")
      }, {
        title: "Invest",
        href: "".concat(t, "/invest/")
      }, {
        title: "Landlord Insurance",
        href: "".concat(t, "/insurance")
      }, {
        title: "Vacation Rental Software",
        href: "".concat(t, "/vacation-rental-software")
      }]
    }, {
      columnName: "Features",
      links: [{
        title: "Airbnb Data",
        href: "".concat(t, "/airbnb-data")
      }, {
        title: "Market Finder",
        href: "".concat(t, "/product/market-finder")
      }, {
        title: "Property Finder",
        href: "".concat(t, "/explore/property-finder")
      }, {
        title: "Airbnb for Sale",
        href: "".concat(t, "/airbnb-for-sale")
      }, {
        title: "Airbnb Calculator",
        href: "".concat(t, "/airbnb-calculator")
      }, {
        title: "Airbnb Dynamic Pricing",
        href: "".concat(t, "/features/dynamic-pricing")
      }]
    }, {
      columnName: "Resources",
      links: [{
        title: "Blog",
        href: "".concat(t, "/blog/")
      }, {
        title: "Help Center",
        href: "https://help.mashvisor.com/en"
      }, {
        title: "Vacation Rental Guide",
        href: "".concat(t, "/blog/vacation-rental-guide/")
      }, {
        title: "Investor Resource Center",
        href: "".concat(t, "/blog/investor-tools/")
      }, {
        title: "Real Estate Investing Guide",
        href: "".concat(t, "/blog/real-estate-investing-guide/")
      }]
    }]
  }[e];
};
export { l as getFooterLinks };